export default "/images/framework/WordPlayerCht.09565a2c.svg?09565a2c";